// Theme helpers for applying custom branding (accent color) at runtime.

export function hexToHsl(hex) {
  const h6 = (hex || '#2EE6C5').replace('#', '');
  const r = parseInt(h6.slice(0, 2), 16) / 255;
  const g = parseInt(h6.slice(2, 4), 16) / 255;
  const b = parseInt(h6.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      default: h = (r - g) / d + 4;
    }
    h /= 6;
  }
  return { h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100) };
}

export function hslToHex(h, s, l) {
  s /= 100; l /= 100;
  const k = (n) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n) => {
    const color = l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return Math.round(255 * color);
  };
  const toHex = (x) => x.toString(16).padStart(2, '0');
  return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`;
}

export function lighten(hex, amount = 14) {
  const { h, s, l } = hexToHsl(hex);
  return hslToHex(h, s, Math.min(100, l + amount));
}

export function luminance(hex) {
  const h6 = (hex || '#2EE6C5').replace('#', '');
  const r = parseInt(h6.slice(0, 2), 16);
  const g = parseInt(h6.slice(2, 4), 16);
  const b = parseInt(h6.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}

export function applyBranding(settings) {
  if (!settings) return;
  const root = document.documentElement;
  const c1 = settings.accent_color || '#2EE6C5';
  const c2 = settings.accent_color_2 || lighten(c1, 10);
  const { h, s, l } = hexToHsl(c1);
  root.style.setProperty('--primary', `${h} ${s}% ${l}%`);
  root.style.setProperty('--ring', `${h} ${s}% ${l}%`);
  root.style.setProperty('--cx-primary', c1);
  root.style.setProperty('--cx-primary-2', c2);
  root.style.setProperty('--cx-ring', c1);
  root.style.setProperty('--cx-brand-gradient', `linear-gradient(135deg, ${c1}, ${c2})`);
  root.style.setProperty('--primary-foreground', luminance(c1) > 0.6 ? '172 84% 7%' : '0 0% 100%');
}
